import { getTopDivisions } from '@aurouscia/china-areas/dist/index.js'
import { toOption } from '@/features/master-data/utils/region.ts'

export const REGION_OPTIONS = getTopDivisions().map(toOption)
